// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__375-r","newExpiryDate":"styles_newExpiryDate__ASUIw","footer":"styles_footer__1d95H"};